export default "__VITE_ASSET__66de3fd8__"